import { render, staticRenderFns } from "./product_detail.vue?vue&type=template&id=2cebca50&scoped=true"
import script from "./product_detail.vue?vue&type=script&lang=js"
export * from "./product_detail.vue?vue&type=script&lang=js"
import style0 from "./product_detail.vue?vue&type=style&index=0&id=2cebca50&prod&lang=scss&scoped=true"
import style1 from "./product_detail.vue?vue&type=style&index=1&id=2cebca50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cebca50",
  null
  
)

export default component.exports